import { useRMDispatch, useRMSelector } from 'redux/hooks';
import { replaceSelectedLayerDetail } from 'redux/reducers/experimentDataReducer';
import {
  selectExperimentLayers,
  selectSelectedLayer,
  selectSelectedLayerId,
} from 'redux/selectors/ExperimentStateSelector';
import {
  selectIsEditable,
  selectIsModifyAccessRights,
} from 'redux/selectors/StateSelectors';

export const useExpTreeNodeId = () => {
  return useRMSelector((state) => state.experiment.expData?.treeNodeId);
};

export const useExpId = () => {
  return useRMSelector((state) => state.experiment.expData?.experimentId);
};

export const useSelectedLayerId = () => {
  return useRMSelector(selectSelectedLayerId);
};

export const useIsEditMode = () => {
  return useRMSelector(selectIsEditable);
};

export const useExpLayers = () => {
  return useRMSelector(selectExperimentLayers);
};

export const useModifyAccessRights = () => {
  return useRMSelector(selectIsModifyAccessRights);
};

export const useSelectedExpLayer = () => {
  return useRMSelector(selectSelectedLayer);
};

export const useSetSelectedLayerDetail = () => {
  const dispatch = useRMDispatch();
  return (layer) => {
    dispatch(replaceSelectedLayerDetail(layer));
  };
};
